import type { SponsoredProduct } from './interfaces/sponsoredProduct';

export interface SponsoredProductsState {
  fetching: boolean;
  error?: string;
  items: SponsoredProduct[];
  positions: number[];
}

export const sponsoredProductInitialState: SponsoredProductsState = {
  fetching: false,
  items: [],
  positions: [],
};
